// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UnitOfMeasure } from "./UnitOfMeasure";
import {
  UnitOfMeasureFromJSON,
  UnitOfMeasureFromJSONTyped,
  UnitOfMeasureToJSON,
  UnitOfMeasureToJSONTyped,
} from "./UnitOfMeasure";
import type { PhysicalQuantity } from "./PhysicalQuantity";
import {
  PhysicalQuantityFromJSON,
  PhysicalQuantityFromJSONTyped,
  PhysicalQuantityToJSON,
  PhysicalQuantityToJSONTyped,
} from "./PhysicalQuantity";

/**
 *
 * @export
 * @interface RangeType
 */
export interface RangeType {
  /**
   *
   */
  min: number;
  /**
   *
   */
  max: number;
  /**
   *
   */
  physicalQuantity?: PhysicalQuantity;
  /**
   *
   */
  unit?: UnitOfMeasure | null;
}

/**
 * Check if a given object implements the RangeType interface.
 */
export function instanceOfRangeType(value: object): value is RangeType {
  if (!("min" in value) || value["min"] === undefined) return false;
  if (!("max" in value) || value["max"] === undefined) return false;
  return true;
}

export function RangeTypeFromJSON(json: any): RangeType {
  return RangeTypeFromJSONTyped(json, false);
}

export function RangeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RangeType {
  if (json == null) {
    return json;
  }
  return {
    min: json["min"],
    max: json["max"],
    physicalQuantity:
      json["physical_quantity"] == null
        ? undefined
        : PhysicalQuantityFromJSON(json["physical_quantity"]),
    unit:
      json["unit"] === undefined
        ? undefined
        : json["unit"] === null
        ? null
        : UnitOfMeasureFromJSON(json["unit"]),
  };
}

export function RangeTypeToJSON(json: any): RangeType {
  return RangeTypeToJSONTyped(json, false);
}

export function RangeTypeToJSONTyped(
  value?: RangeType | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    min: value["min"],
    max: value["max"],
    physical_quantity: PhysicalQuantityToJSON(value["physicalQuantity"]),
    unit: UnitOfMeasureToJSON(value["unit"]),
  };
}
